import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Trophy, Crown, Medal, Shield, CheckCircle } from 'lucide-react';

var CIRCLE_DOT_COLORS = {
  Bronze: 'bg-amber-700',
  Silver: 'bg-slate-400',
  Gold: 'bg-yellow-500',
  Platinum: 'bg-slate-300',
  Diamond: 'bg-cyan-300',
};

function RankIcon(props) {
  var index = props.index;
  if (index === 0) return <Crown size={18} className="text-amber-400" />;
  if (index === 1) return <Medal size={18} className="text-slate-400" />;
  if (index === 2) return <Medal size={18} className="text-amber-700" />;
  return <span className="text-xs font-bold text-slate-400 w-[18px] text-center">{index + 1}</span>;
}

function LeaderRow(props) {
  var leader = props.leader;
  var index = props.index;
  var rowClass = 'flex items-center gap-3 p-2.5 rounded-xl transition-all ';
  if (leader.is_me) rowClass += 'bg-[#0B1F3A]/5 border border-[#0B1F3A]/20';
  else if (index < 3) rowClass += 'bg-amber-50/50';
  else rowClass += 'bg-slate-50';

  var dotClass = CIRCLE_DOT_COLORS[leader.circle] || 'bg-slate-400';

  return (
    <div className={rowClass} data-testid={'leaderboard-row-' + index}>
      <div className="w-8 flex justify-center"><RankIcon index={index} /></div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-slate-800 truncate">
          {leader.user_name} {leader.is_me && <span className="text-xs text-[#2272C5]">(You)</span>}
        </p>
        <div className="flex items-center gap-2 mt-0.5">
          <span className={'inline-block w-2 h-2 rounded-full ' + dotClass} />
          <span className="text-[10px] text-slate-500">{leader.circle}</span>
          <span className="text-[10px] text-slate-400">|</span>
          <Shield size={10} className="text-blue-500" />
          <span className="text-[10px] text-blue-600 font-medium">{leader.trust_score}</span>
          <span className="text-[10px] text-slate-400">|</span>
          <CheckCircle size={10} className="text-emerald-500" />
          <span className="text-[10px] text-emerald-600 font-medium">{leader.on_time_rate}%</span>
        </div>
      </div>
      <div className="text-right flex-shrink-0">
        <span className="text-sm font-black text-[#0B1F3A]">{leader.credibility_score}</span>
        <p className="text-[9px] text-slate-400">credibility</p>
      </div>
    </div>
  );
}

function RewardsLeaderboard(props) {
  var leaders = props.leaders;
  var myRank = props.myRank;
  var myScore = props.myScore;

  if (!leaders || leaders.length === 0) {
    return (
      <Card className="glass-card" data-testid="rewards-leaderboard-empty">
        <CardContent className="p-8 text-center">
          <Trophy size={36} className="mx-auto text-slate-300 mb-2" />
          <p className="text-sm text-slate-500">No one on the leaderboard yet. Be the first!</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-3" data-testid="rewards-leaderboard">
      {myRank > 0 && (
        <Card className="glass-card border-2 border-[#0B1F3A]/20 mb-3">
          <CardContent className="p-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-xs font-bold text-[#0B1F3A] bg-[#0B1F3A]/10 px-2 py-1 rounded-lg">#{myRank}</span>
              <span className="text-sm font-semibold text-slate-800">Your Rank</span>
            </div>
            <span className="text-sm font-black text-[#0B1F3A]">{myScore} credibility</span>
          </CardContent>
        </Card>
      )}

      <Card className="glass-card">
        <CardHeader className="pb-2">
          <CardTitle className="text-base text-[#0B1F3A] flex items-center gap-2">
            <Shield size={16} className="text-blue-500" /> Trust Leaderboard
          </CardTitle>
          <p className="text-[10px] text-slate-500 mt-0.5">Ranked by financial credibility: trust, reliability, and consistency</p>
        </CardHeader>
        <CardContent className="space-y-1">
          {leaders.map(function(leader, i) {
            return <LeaderRow key={i} leader={leader} index={i} />;
          })}
        </CardContent>
      </Card>
    </div>
  );
}

export default RewardsLeaderboard;
